import {GameDefaultBox} from './game.default.box';

export const GameBox = GameDefaultBox;